import React, { useRef } from "react";
import {
  ScrollView,
  View,
  Image,
  Text,
  Dimensions,
  StyleSheet,
} from "react-native";
import { SvgUri } from "react-native-svg";
import { Video, AVPlaybackStatus } from "expo-av";
import { useSelector, useDispatch } from "react-redux";
import { HeaderButtons, Item } from "react-navigation-header-buttons";
import CastDeviceModal from "../components/CastDeviceModal";
import DefaultText from "../components/text/DefaultText";
import DefaultTextBold from "../components/text/DefaultTextBold";
import Colors from "../constants/Colors";
import MaterialButton from "../components/MaterialButton";

const ListItem = (props) => {
  return (
    <View style={styles.listItem}>
      <DefaultText>{props.children}</DefaultText>
    </View>
  );
};

const ArtScreen = (props) => {
  const { itemId, from } = props.route.params;
  const popularNfts = useSelector((state) => state.nfts.popularNfts);
  const userNfts = useSelector((state) => state.userNfts.myNfts);
  const nftGroup = from === "home" ? popularNfts : userNfts;

  const selectedNft = nftGroup.find((nft) => nft.id === itemId);
  const modalizeRef = useRef(null);
  const video = useRef(null);
  const [status, setStatus] = React.useState({});

  const onOpen = () => {
    modalizeRef.current?.open();
  };
  const onClose = () => {
    modalizeRef.current.close();
  };

  React.useLayoutEffect(() => {
    props.navigation.setOptions({
      headerRight: () =>
        from === "home" ? null : (
          <HeaderButtons HeaderButtonComponent={MaterialButton}>
            <Item title="Cast" iconName={"cast"} onPress={onOpen} />
          </HeaderButtons>
        ),
    });
  }, [props.navigation]);

  let imageUrl = selectedNft.imageUrl;
  if (imageUrl.endsWith("svg")) {
    imageUrl = selectedNft.collectionImageUrl;
  }
  // console.log("ART SCREEN:", imageUrl, selectedNft.animationUrl);
  return (
    <View style={styles.screen}>
      <ScrollView style={styles.scrollContainer}>
        {/* <SvgUri width="100%" height="100%" uri={selectedNft.imageUrl} /> */}
        {selectedNft.animationUrl ? (
          <Video
            ref={video}
            style={styles.video}
            source={{
              uri: selectedNft.animationUrl,
              //uri: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4",
            }}
            useNativeControls
            resizeMode="cover"
            isLooping
            onPlaybackStatusUpdate={(status) => setStatus(() => status)}
            shouldPlay
          />
        ) : (
          <Image source={{ uri: imageUrl }} style={styles.image} />
        )}
        <View style={styles.details}>
          <DefaultTextBold>Art Name</DefaultTextBold>
          <DefaultText>{selectedNft.title}</DefaultText>
        </View>
        <View style={styles.details}>
          <DefaultTextBold>Artist</DefaultTextBold>
          <DefaultText>{selectedNft.artist}</DefaultText>
        </View>
        <View style={styles.details}>
          <DefaultTextBold>Collection</DefaultTextBold>
          <DefaultText>{selectedNft.collection}</DefaultText>
        </View>
        <View style={styles.details}>
          <DefaultTextBold>Blockchain</DefaultTextBold>
          <DefaultText>{selectedNft.blockchain}</DefaultText>
        </View>
        <View style={styles.hline} />
        <View style={styles.contractAddrTitle}>
          <DefaultTextBold>Contract Address</DefaultTextBold>
        </View>
        <View style={styles.contractAddrContent}>
          <DefaultText ellipsizeMode="middle">
            {selectedNft.contractAddr}
          </DefaultText>
        </View>
      </ScrollView>
      <CastDeviceModal
        modalizeRef={modalizeRef}
        castNFT={[selectedNft]}
        onClose={onClose}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    flex: 1,
  },
  image: {
    width: "100%",
    height: Dimensions.get("window").height * 0.5,
    resizeMode: "contain",
  },
  videoContainer: {
    flex: 1,
    justifyContent: "center",
    backgroundColor: "black",
    width: "100%",
    height: Dimensions.get("window").height * 0.5,
  },

  video: {
    alignSelf: "center",
    width: "100%",
    height: Dimensions.get("window").height * 0.5,
  },
  buttons: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  scrollContainer: {},
  details: {
    flexDirection: "row",
    padding: 15,
    justifyContent: "space-between",
  },
  contractAddrTitle: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: 15,
  },
  contractAddrContent: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  hline: {
    borderBottomColor: Colors.primary,
    borderBottomWidth: 1,
    padding: 5,
  },
  title: {
    fontFamily: "open-sans-bold",
    fontSize: 22,
    textAlign: "center",
  },
  listItem: {
    marginVertical: 10,
    marginHorizontal: 20,
    borderColor: "#ccc",
    borderWidth: 1,
    padding: 10,
  },
});

export default ArtScreen;
